<div class="header">
  <h3>{{'HISTORY.HEAD' | translate}}</h3>
</div>
<div class="box-filter position-relative z-2">
  <app-filter-header [loading]="loading" (search)="searchButtonClicked()" (clear)="clearData()"></app-filter-header>
  <div class="row row-eq-height">
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="username"
          [options]="usernames"
          [(ngModel)]="searchUsername"
          [autoDisplayFirst]="false"
          placeholder="{{'HISTORY.USERNAME' | translate}}"
          [style]="{'z-index': 4}"
        >
        </p-dropdown>
        <label for="username">{{'HISTORY.USERNAME' | translate}}</label>
      </div>
    </div>
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectId="group"
          [options]="roles"
          [(ngModel)]="searchRole"
          [autoDisplayFirst]="false"
          placeholder="{{'HISTORY.ROLE' | translate}}"
        >
        </p-dropdown>
        <label for="group">{{'HISTORY.ROLE' | translate}}</label>
      </div>
    </div>
  </div>
  <div class="row row-eq-height m-t-10">
    <div class="col-md-4">
      <div class="dropdown-label-group">
        <p-dropdown
          class="dv-dropdown"
          selectedId="action"
          [options]="actions"
          [(ngModel)]="searchAction"
          [autoDisplayFirst]="false"
          placeholder="{{'HISTORY.ACTION' | translate}}"
        >
        </p-dropdown>
        <label for="action">{{'HISTORY.ACTION' | translate}}</label>
      </div>
    </div>
    <div class="col-md-4">
      <div class="dropdown" #dd="ngbDropdown" ngbDropdown autoClose="outside">
        <div class="form-label-group">
          <input #ddi class="form-control" type="text" id="calendarDropdown" [value]="dateRange" ngbDropdownToggle
                 placeholder="วันที่" readonly>
          <label for="calendarDropdown">{{'HISTORY.DATE' | translate}}</label>
          <div class="calendar-trigger" (click)="$event.stopPropagation(); sentDate(); dd.toggle()">
            <span class="far fa-calendar"></span>
          </div>
        </div>
        <div class="dropdown-menu" ngbDropdownMenu aria-labelledby="calendarDropdown">
          <div class="row">
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.SINCE' | translate}}</div>
            <div class="col" style="padding-left: 30px">{{'FILTER.CALENDAR.UNTIL' | translate}}</div>
          </div>
          <div (click)="$event.stopPropagation()">
            <p-calendar [(ngModel)]="startDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMinDate" [inline]="true"
                        [locale]="calendarLocale"></p-calendar>
            <p-calendar [(ngModel)]="endDate" [defaultDate]="startDate" dateFormat="dd/mm/yy" [minDate]="minDate"
                        readonlyInput="true" [showIcon]="true" [monthNavigator]="true" [yearNavigator]="true"
                        [yearRange]="yearRange" (onSelect)="setMaxDate(); dd.close()" [inline]="true"
                        [locale]="calendarLocale">
            </p-calendar>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="box-parent position-relative z-1">
  <app-custom-pagination
    [(currentPage)]="currentPage"
    [(itemsPerPage)]="itemsPerPage"
    [totalItems]="totalItems"
    [maxSize]="5"
    (pageChange)="pageChanged()"
    (optionChange)="searchButtonClicked()"
    *ngIf="loading === false && totalItems !== 0"
  >
    <button type="button" class="btn btn-dv btn-wide" [disabled]="loading_excel_report" (click)="DownloadReport()">
      <i *ngIf="loading_excel_report" class="fa fa-spinner fa-spin m-r-5"></i>
      {{'IMPORT-DATA.DOWNLOAD-REPORT' | translate}}
    </button>
  </app-custom-pagination>

  <div class="row m-t-20" *ngIf="totalItems === 0 && loading === false">
    <div class="col-12 text-center">
      <h5>{{'COMMON.DATA-NOT-FOUND' | translate}}</h5>
    </div>
  </div>

  <div class="m-t-20 text-center">
    <p-table #tt tableStyleClass="table" *ngIf="totalItems !== 0" [loading]="loading"
             [columns]="tableCol" [value]="tableData" [customSort]="true" (onSort)="sort($event)" [autoLayout]="true">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col">{{'COMMON.TABLE.ORDER' | translate}}</th>
          <th id="th-not-order" *ngFor="let col of columns" [pSortableColumn]="col.field" (click)="pageChanged()">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data let-index="rowIndex">
        <tr>
          <td>{{index + 1 + ((currentPage - 1) * itemsPerPage)}}</td>
          <td>{{data.created_at | date:"dd/MM/yyyy HH:mm" }}</td>
          <td>{{data.role_name}}</td>
          <td>{{data.username}}</td>
          <td class="text-left" *ngIf="data.target">{{data.action_display | translate}} - {{data.target}}</td>
          <td class="text-left" *ngIf="!data.target">{{data.action_display | translate}}</td>
          <td>{{data.address_display | translate}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>



// WEBPACK FOOTER //
// /opt/app/src/app/features/history-log/history-log.component.html